// localStorage helpers for tracking customer's recent orders + email
const ORDERS_KEY = "stealodeal_recent_orders_v1";
const EMAIL_KEY = "stealodeal_customer_email_v1";

export const saveRecentOrder = (order) => {
  try {
    const raw = localStorage.getItem(ORDERS_KEY);
    const list = raw ? JSON.parse(raw) : [];
    const entry = {
      id: order.id,
      razorpay_order_id: order.razorpay_order_id,
      amount_inr: order.amount_inr,
      status: order.status,
      created_at: order.created_at,
      items_count: (order.items || []).length,
    };
    const filtered = list.filter((x) => x.id !== entry.id);
    filtered.unshift(entry);
    localStorage.setItem(ORDERS_KEY, JSON.stringify(filtered.slice(0, 20)));
    if (order.customer_email) localStorage.setItem(EMAIL_KEY, order.customer_email);
  } catch {
    /* ignore */
  }
};

export const getRecentOrders = () => {
  try {
    const raw = localStorage.getItem(ORDERS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const getSavedEmail = () => {
  try {
    return localStorage.getItem(EMAIL_KEY) || "";
  } catch {
    return "";
  }
};
